import { signal } from "@preact/signals";

/**
 * Boot sequence state (driven by app/boot.ts, rendered by App):
 *  - loading: contacting the server / loading the catalog
 *  - name:    no valid session, show the first-run name prompt
 *  - error:   server unreachable (retry screen)
 *  - ready:   authenticated and catalog loaded, show the menus
 */
export type BootStatus = "loading" | "name" | "error" | "ready";

export const bootStatus = signal<BootStatus>("loading");
export const bootError = signal<string>("");
